import { handleRequest } from "../utilities/requestHandler";

export const contactCCR = (formData) =>
    handleRequest("post", "/machines/contact-ccr", formData);